export default __webpack_public_path__ + "static/media/feather_x.3523a6f7.svg";